import { typoMixin } from '@/styles/mixins/typo-mixin'
import { loadingAnimationMixin } from '@/styles/mixins/loading-mixin'
import { makeStyles, css } from '@conexasaude/hero'
import { BREAKPOINT_SIZES } from '@/styles/mixins/breakpoint-mixin'

const useStyles = makeStyles({
  wrapper: () => css`
    margin-top: 56px;
    display: flex;

    @media (max-width: 639px) {
      margin-top: 24px;

      &:not(:first-of-type) {
        margin-top: 0;
      }
    }
  `,

  header: () => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    @media (max-width: 639px) {
      display: none;
    }
  `,

  title: ({ typography }) => css`
    ${typoMixin({ typography }, 'h3')};
  `,

  cardWrapper: () => css`
    > a {
      margin-bottom: 16px;
    }
  `,
  consultationCard() {
    return css`
      margin-top: 26px;
      flex-wrap: wrap;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;
      @media (max-width: 639px) {
        margin-bottom: 16px;
      }
    `
  },

  skeletonWrapper: () => css`
    margin-top: 56px;
  `,

  skeletonTitle: theme => css`
    display: flex;
    width: 156px;
    height: 28px;
    margin-bottom: 20px;
    border-radius: 8px;
    ${loadingAnimationMixin(
      theme.colors.neutral[100],
      theme.colors.neutral[200],
    )};
  `,

  skeletonCardWrapper: () => css`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    flex-wrap: wrap;

    @media (min-width: ${BREAKPOINT_SIZES.tablet.minWidth}) {
      grid-template-columns: 1fr 1fr;
    }

    @media (min-width: ${BREAKPOINT_SIZES.desktop.minWidth}) {
      grid-template-columns: 1fr 1fr 1fr;
    }
  `,

  skeletonCard: theme => css`
    display: flex;
    width: 100%;
    height: 177px;
    border-radius: 8px;
    ${loadingAnimationMixin(
      theme.colors.neutral[100],
      theme.colors.neutral[200],
    )};
  `,
})

export { useStyles }
